<template>

  <div class="live-wrapper">
    <van-list v-if="list.length"  v-model="loading" :finished="finished" :immediate-check="immediate" :finished-text="finishedTxt" @load="moreList">
      <div class="job-zt-list-1">
        <div class="item-box" v-for="(item,index) in list" :key="index">
          <a class="item" :href="item.play_url">
            <!--            <router-link>-->
            <img :src="item.cover" alt="">
            <div class="top-box justify-align">
              <div>
                <div class="top-lf content-center" :style="{padding: (item.live_status == 0?'0':'')}">
                  <template v-if="item.live_status==1">
                    <img :src="require('../../assets/'+appTheme+'/zhiboz_icon.png')" alt="" />
                    <span>直播中</span>
                  </template>
                  <template v-else-if="item.live_status==2">
                    <img :src="require('../../assets/'+appTheme+'/zhibo_huo.png')" alt="" />
                    <span>热播</span>
                  </template>
                  <template v-else-if="item.live_status==3">
                    <img :src="require('../../assets/'+appTheme+'/zhibo_huo.png')" alt="" />
                    <span>热搜</span>
                  </template>
                  <template v-else-if="item.zhibo_new==4">
                    <img :src="require('../../assets/'+appTheme+'/zhibo_huo.png')" alt="" />
                    <span>首发</span>
                  </template>
                  <template v-else-if="item.zhibo_new==5">
                    <img :src="require('../../assets/'+appTheme+'/vip_icon.png')" alt="" />
                    <span>VIP</span>
                  </template>
                  <template v-else-if="item.zhibo_new==6">
                    <img :src="require('../../assets/'+appTheme+'/zhibo_vr.png')" alt="" />
                    <span>VR</span>
                  </template>
                </div>
              </div>

              <!--                <div class="top-rt left-justifying"><div class="xin-icon-box"><img src="../../assets/xin_zhibo.png" alt="" /></div>{{item.likes}}</div>-->

            </div>
            <div class="title-box">
              <div class="justify-align">
                <div class="zan-box left-justifying">
                  <div v-for="(icon,i) in item.items" :key="i">
                    <img v-if="icon=='hongbao'" :src="require('../../assets/'+appTheme+'/zhibo1.png')" alt="" />
                    <img v-if="icon=='bonus'" :src="require('../../assets/'+appTheme+'/zhibo2.png')" alt="" />
                    <img v-if="icon=='onepay'" :src="require('../../assets/'+appTheme+'/zhibo3.png')" alt="" />
                    <img v-if="icon=='daka'" :src="require('../../assets/'+appTheme+'/zhibo4.png')" alt="" />
                    <img v-if="icon=='star'" :src="require('../../assets/'+appTheme+'/zhibo6.png')" alt="" />
                    <img v-if="icon=='gift'" :src="require('../../assets/'+appTheme+'/zhibo5.png')" alt="" />
                  </div>

                </div>
                <div class="top-rt left-justifying"><div class="xin-icon-box"><img class="top-rt-img" :src="require('../../assets/'+appTheme+'/xin_zhibo.png')" alt="" /></div>{{item.likes}}</div>

              </div>

              <div class="title-txt">{{item.title}}</div>
            </div>
            <!--            </router-link>-->
          </a>
        </div>
      </div>
    </van-list>
    <div style="text-align: center;margin-top: 20vw;" v-else>暂无数据</div>
    <div class="null-box"></div>
    <!--    <div class="tab-bar-box">-->
    <!--      <div class="tab-bar-box-content">-->
    <!--        <div class="tab-item content-center" @click="goHome">-->
    <!--          <img src="../../assets/f_home.png" alt="" />首页-->
    <!--        </div>-->
    <!--        &lt;!&ndash;        <div class="tab-item content-center">&ndash;&gt;-->
    <!--        &lt;!&ndash;          <img src="../../assets/f_apply_for.png" alt="" />申请探厂&ndash;&gt;-->
    <!--        &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { getMaterialData } from '@/api/zhibo'
export default {
  name: "materialList",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      list: [],
      cover_img: require('@/assets/live-img.jpg'),
      loading: false, // 加载状态
      finished: false, // 是否加载
      page: 1,
      currentPage: 1,
      immediate: false,
      finishedTxt: '没有更多了~',
      statusType: 'null',
      actEndTimeList: [],// 提取出来的倒计时数组列表
      countDownList: [], // 显示倒计时
      timer:null
    }
  },
  beforeCreate() {		//在页面创建之前设置body的背景色
    // console.log('创建')
    document.querySelector('body').setAttribute('style', 'background: #fff;')
  },
  beforeDestroy() {		//在页面销毁之前移除body的属性，目的是设置的颜色只对当前页面有效
    // document.querySelector('body').removeAttribute('style')
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    // console.log('离开界面')
    document.querySelector('body').setAttribute('style', '')
    next()
  },
  created() {
    this.getList()
    this.$store.commit("setLiveItem",'')
  },
  //生命周期 destroyed销毁定时器
  destroyed(){
    // console.log('销毁')
    clearTimeout(this.timer);
    this.timer = null;
  },
  methods: {
    goHome(){
      this.$router.push('/');
    },
    goDes(item){
      console.log(item.href)
      // this.$router.push({path:'/liveDes2',query: {item:item}})
      if (item.live_type=='live'){ // 直播
        if (item.href != null){
          window.open(item.href)
        } else {
          // 获取设备信息并判断是否是ios
          // let u = navigator.userAgent;
          // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          // if (isiOS) {
          //   // ios系统就拼接随机字符串
          //   var url = 'https://jpzs-zst.itos.cn/zhiBoDes?id='+item.id
          //     window.open(url)
          // } else {
          //   this.$router.push({path:'/zhiBoDes',query: {id:item.id}})
          // }
          this.$router.push({path:'/zhiBoDes',query: {id:item.id}})
        }
        // window.open(item.href)
        // this.$router.push({path:'/zhiBoDes',query: {id:item.id}})
      } else { // 重播
        this.$router.push({path:'/liveDes2',query: {id:item.id}})
        // this.$router.push({path:'/liveDes',query: {id:item.id}})
      }

    },
    getList(){
      var that = this
      var data = {
        page:1
      }
      getMaterialData(data).then(res => {
        if(res.code == 200)
        {
          this.loading = true; // 防止多次触发load事件
          console.log('res',res.data.data)
          that.list = res.data.data

          // 加载状态结束
          this.loading = false;
          if (res.data.data.length == res.data.total){ // 数据全部加载完
            that.finished = true; // 数据全部加载完
            if(res.data.data.length == 0){
              this.finishedTxt = '暂无数据~'
            } else {
              this.finishedTxt = '没有更多了~'
            }
          }else {
            that.finished = false; // 可以加载
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    moreList(){
      var that = this
      this.currentPage += 1;//页数+1
      var data = {
        page:this.currentPage
      }
      getMaterialData(data).then(res => {
        if(res.code == 200)
        {
          this.loading = true;
          var arr = this.list.concat(res.data.data);
          that.list = arr
          // console.log(that.list.length)
          let endTimeList = [];
          //定义一个新数组，将活动的结束时间参数提成一个单独的数组
          // for(let i=0;i< that.list .length;i++){
          //   var objs = {};
          //   objs.eTime =String(that.list[i].live_time).replace(/\-/g, '/')
          //   objs.finish = false
          //   endTimeList .push(objs)
          //
          // }
          // // console.log(999)
          // that.actEndTimeList =  endTimeList
          // console.log('en',that.actEndTimeList)
          // 加载状态结束
          this.loading = false;
          // console.log(res.data.data.length)
          if (that.list.length == res.data.total) { // 数据全部加载完成
            this.finished = true; // 防止多次触发load事件
            console.log('加载完毕')
          } else {
            this.finished = false;
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
 .tab-bar-box{
   position: fixed;left: 0;bottom: 0;
   width: 100%;
   padding: 40px 0;color: #FFFFFF;font-size: 32px;
   background: #0F0F0F;
   .tab-bar-box-content{
     .tab-item{
       //width: 50%;
       img{
         width: 52px;height: auto;display: inline-block;margin-right: 15px;
       }
     }
   }
 }
.job-zt-list-1 {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  padding: 1px;
  .item-box {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    text-align: center;
    .item{
      position: relative;
      //width: 100%;
      overflow: hidden;
      margin: 15px 20px 15px 0;
      //height: 512px;
      display: inline-block;
      //width: 342px;
      height: 540px;
      border-radius: 20px;
      //a{
      //  display: block;
      //}
      img {
        width: 100%;display: block; height: 540px; border-radius: 20px;
      }
      .title-box{
        //padding-top: 20px;
        background: linear-gradient(transparent,#000);
        width: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        color: #fff;
        .zan-box{
          text-align: left;
          padding-left: 15px;
          position: relative;
          //justify-content: flex-end;
          //align-items: self-end;
          img{
            width: 38px;
            height: auto;display: inline-block;margin-right: 5px;
          }
        }
        .title-txt{
          overflow: hidden;
          padding: 5px 15px 5px;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;font-size: 28px;
        }
      }
      .top-box{
        position: absolute;top:20px;width: 100%;left: 0;color: #FFFFFF;font-size: 20px;
        img{
          width: 32px;height: auto;display: inline-block;margin-right: 5px;
        }
        .top-lf{
          max-width: 110px;
          padding: 5px 20px 5px 5px;
          background: #F03926;
          border-radius: 20px;margin-left: 10px;
        }

      }
      .time-box{
        position: absolute;top:80px;width:85%;left: 10px;
        padding: 5px 10px;
        background: rgba(0, 0, 0, 0.5);font-size: 20px;
        border-radius: 80px;color: #FFFFFF;
      }
    }
  }
  .item-box:nth-child(odd) .item{
    margin-left: 15px;
  }
}
.countDownList{
  color: #fff;font-size: 24px;
}
.top-rt{
  padding: 5px 10px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 80px;margin-right: 10px;
  .xin-icon-box{
    padding: 5px 8px;
    background: #F23926;margin-right: 5px;
    opacity: 0.99;
    border-radius: 50px;
    .top-rt-img{
      width: 18px !important;
      height: 16px !important;
    }
  }
}
</style>
